import { useTranslation } from 'react-i18next';

const useDaysOfTheWeek = () => {
  const { t } = useTranslation('translation');
  return [
    t('common.sun'),
    t('common.mon'),
    t('common.tue'),
    t('common.wed'),
    t('common.thu'),
    t('common.fri'),
    t('common.sat'),
  ];
};

export default useDaysOfTheWeek;
